import { useEffect, useState } from 'react';
import { Modal } from '../common/Modal';

export type UpdateStoredLocationPayload = {
  caseRequestId: string;
  fileRef: string;
  location: string;
};

type UpdateStoredLocationModalProps = {
  open: boolean;
  fileRef: string;
  initialLocation?: string;
  onClose: () => void;
  /** Called when user confirms; wire to API PATCH when ready. */
  onUpdate?: (payload: Pick<UpdateStoredLocationPayload, 'fileRef' | 'location'>) => void | Promise<void>;
  saving?: boolean;
  errorMessage?: string | null;
};

export function UpdateStoredLocationModal({
  open,
  fileRef,
  initialLocation = '',
  onClose,
  onUpdate,
  saving = false,
  errorMessage,
}: UpdateStoredLocationModalProps) {
  const [locationDraft, setLocationDraft] = useState(initialLocation);

  useEffect(() => {
    if (open) setLocationDraft(initialLocation);
  }, [open, initialLocation]);

  const canSubmit = locationDraft.trim().length > 0 && !saving;

  const handleUpdate = () => {
    if (!canSubmit) return;
    void onUpdate?.({ fileRef, location: locationDraft.trim() });
  };

  return (
    <Modal open={open} title="Update Physical File Stored Location" onClose={onClose} boxClassName="cn-mbox-location">
      <div style={{ marginBottom: 14 }}>
        <label className="fl" style={{ marginBottom: 6 }}>
          File Ref. No.
        </label>
        <input className="inp cn-loc-ref" type="text" readOnly value={fileRef} aria-readonly />
      </div>
      {errorMessage ? (
        <div className="si-err" style={{ marginBottom: 12 }}>
          {errorMessage}
        </div>
      ) : null}
      <div style={{ marginBottom: 4 }}>
        <label className="fl" style={{ marginBottom: 6 }}>
          Enter Location <span className="req">*</span>
        </label>
        <textarea
          className="inp"
          style={{ minHeight: 90, resize: 'vertical' }}
          value={locationDraft}
          onChange={(e) => setLocationDraft(e.target.value)}
          placeholder="Enter the physical stored location..."
          maxLength={2000}
          disabled={saving}
        />
      </div>
      <div className="cn-footer cn-footer--plain">
        <button className="mfb" type="button" onClick={onClose} disabled={saving}>
          Cancel
        </button>
        <button className="mfb mfb-dk" type="button" onClick={handleUpdate} disabled={!canSubmit}>
          {saving ? 'Updating…' : 'Update'}
        </button>
      </div>
    </Modal>
  );
}
